import { IAPIPaymentReceiptViewModel } from "../interfaces";

/**
 * Absolute URL of the public receipt page for a receipt the pay API returned.
 *
 * Prefers the API's own `receiptUrl`, built from ApplicationSettings.PurchaseBaseURL. The EMAIL needs
 * that setting because it has no browser origin to work from - a confirmation screen does, and it is
 * served by the very app that hosts /payment-receipt/{token}, so it falls back to its own origin.
 *
 * That fallback matters: without it, an unset PurchaseBaseURL silently sent the download somewhere
 * else entirely, which is how the old jsPDF renderer kept producing the previous receipt design long
 * after this one shipped.
 *
 * Returns "" when there is no token at all (a payment recorded before receipt tokens existed and
 * never re-sent), which callers should treat as "no receipt to open".
 */
export const buildReceiptUrl = (
  receipt: IAPIPaymentReceiptViewModel | null | undefined,
): string => {
  if (!receipt) return "";
  if (receipt.receiptUrl && receipt.receiptUrl.trim()) {
    return receipt.receiptUrl.trim();
  }
  if (receipt.receiptToken && receipt.receiptToken.trim()) {
    return `${window.location.origin}/payment-receipt/${receipt.receiptToken.trim()}`;
  }
  return "";
};
